import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'

const ExtensionCheckbox = ({
  extension: { id, extension: friendlyName },
  checked,
  onChange,
}) => (
  <Checkbox
    value={id}
    checked={checked}
    onChange={({ target: { value } }) => onChange(value)}
  >
    {friendlyName}
  </Checkbox>
)

ExtensionCheckbox.propTypes = {
  extension: PropTypes.shape({
    id: PropTypes.number.isRequired,
    extension: PropTypes.string.isRequired,
    external_id: PropTypes.number,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
}

export default ExtensionCheckbox



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ExtensionCheckbox.js